/*!
 * Copyright © 2024. Verizon Connect Ireland Limited. All rights reserved.
 */

import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IVideoDeviceInfoState } from '../state/video-device-info.state';

export const getVideoDeviceInfoState = createFeatureSelector<IVideoDeviceInfoState>('videoDeviceInfo');

export const getEarliestRecordingUtc = createSelector(getVideoDeviceInfoState, (state: IVideoDeviceInfoState): Date => state.earliestRecordingUTC);

export const getOnline = createSelector(getVideoDeviceInfoState, (state: IVideoDeviceInfoState): boolean => state.online);

export const getIsVodEnabled = createSelector(getVideoDeviceInfoState, (state: IVideoDeviceInfoState): boolean => state.isVodRequestEnabled);
